/*
 * @Author: wzh
 * @LastEditTime: 2023-05-31 09:25:44
 * @Description: 需登录之后可访问的路由
 */
// 我的应组件
import { home } from "@/views/home";
import { homeLayout, secondLayout,secondLayoutOut } from "@/components/layout";
// 账号管理组件
import { set, third, relative, identify, SocialLogin } from "@/views/account";
// 认证记录组件
import { current, accmant, appvisit, authac, passmant } from "@/views/certife";
// 个人资料组件
import { personal } from "@/views/personal";
// 偏好设置组件
import { love } from "@/views/love";

export default [

  {
    path: "/authserver",
    name: homeLayout.name,
    component: homeLayout,
    redirect: "/authserver/index",
    children: [
      {
        path: "index",
        name: "myApp",
        component: home,
        meta: {
          title: "我的应用",
          field: "my_app",
          keepAlive: false,
          menu: true,
          menuLevel: 1,
          parentName: "myApp",
          icon: "appstore",
        },
      },
     
      {
        path: "account",
        component: secondLayout,
        name: "account",
        redirect: "/authserver/account/set",
        meta: {
          title: "账号安全",
          field: "account_safe",
          keepAlive: false,
          menu: true,
          menuLevel: 1,
          parentName: "account",
          icon: "safety-certificate",
        },
        children: [
          {
            path: "set",
            name: set.name,
            component: set,
            meta: {
              title: "账号设置",
              field: "account_set",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "account",
            },
          },
          {
            path: "third",
            name: third.name,
            component: third,
            meta: {
              title: "第三方账户",
              field: "account_third",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "account",
            },
          },
          {
            path: "relative",
            name: relative.name,
            component: relative,
            meta: {
              title: "关联账号",
              field: "account_related",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "account",
            },
          },
          {
            path: "social",
            name: SocialLogin.name,
            component: SocialLogin,
            meta: {
              title: "社交账号绑定",
              field: "social_login",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "account",
            },
          },
          // {
          // 	path: "identify",
          // 	name: identify.name,
          // 	component: identify,
          // 	meta: { title: "生物识别", keepAlive: false, menu: true, menuLevel: 2, parentName: "account" },
          // },
        ],
      },
      {
        path: "certife",
        component: secondLayout,
        name: "certife",
        redirect: "/authserver/certife/current",
        meta: {
          title: "认证记录",
          field: "certify_record",
          keepAlive: false,
          menu: true,
          menuLevel: 1,
          parentName: "certife",
          icon: "file-text",
        },
        children: [
          {
            path: "current",
            name: current.name,
            component: current,
            meta: {
              title: "当前登录",
              field: "current_login",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "certife",
            },
          },
          {
            path: "authac",
            name: authac.name,
            component: authac,
            meta: {
              title: "账号认证",
              field: "account_certify",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "certife",
            },
          },
          {
            path: "passmant",
            name: passmant.name,
            component: passmant,
            meta: {
              title: "密码维护",
              field: "password_action",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "certife",
            },
          },
          {
            path: "accmant",
            name: accmant.name,
            component: accmant,
            meta: {
              title: "账号维护",
              field: "account_action",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "certife",
            },
          },
          {
            path: "appvisit",
            name: appvisit.name,
            component: appvisit,
            meta: {
              title: "应用访问",
              field: "app_action",
              keepAlive: false,
              menu: true,
              menuLevel: 2,
              parentName: "certife",
            },
          },
        ],
      },
      {
        path: "personal",
        name: "personal",
        component: personal,
        meta: {
          title: "个人资料",
          field: "personal_data",
          keepAlive: false,
          menu: true,
          menuLevel: 1,
          parentName: "personal",
          icon: "user-add",
        },
      },
      {
        path: "love",
        name: "love",
        component: love,
        meta: {
          title: "偏好设置",
          field: "love_set",
          keepAlive: false,
          menu: true,
          menuLevel: 1,
          parentName: "love",
          icon: "heart",
        },
      },
    ],
  },  {
    path: "/account_out",
    component: secondLayoutOut,
    name: "account_out",
    redirect: "/account_out/set",
    meta: {
      title: "账号安全",
      field: "account_safe",
      keepAlive: false,
      menu: true,
      menuLevel: 1,
      parentName: "myApp",
      icon: "safety-certificate",
    },
    children: [
      {
        path: "set",
        name: set.name,
        component: set,
        meta: {
          title: "账号设置",
          field: "account_set",
          keepAlive: false,
          menu: true,
          menuLevel: 2,
          parentName: "account_out",
        },
      },
      {
        path: "third",
        name: third.name,
        component: third,
        meta: {
          title: "第三方账户",
          field: "account_third",
          keepAlive: false,
          menu: true,
          menuLevel: 2,
          parentName: "account_out",
        },
      },
      {
        path: "relative",
        name: relative.name,
        component: relative,
        meta: {
          title: "关联账号",
          field: "account_related",
          keepAlive: false,
          menu: true,
          menuLevel: 2,
          parentName: "account_out",
        },
      },
      {
        path: "social",
        name: SocialLogin.name,
        component: SocialLogin,
        meta: {
          title: "社交账号绑定",
          field: "social_login",
          keepAlive: false,
          menu: true,
          menuLevel: 2,
          parentName: "account_out",
        },
      },
    ],
  },
];
